import { EventEmitter, Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class AlertRulesService {

    alertRuleChanged: EventEmitter<void> = new EventEmitter();

    notifyAlertRuleChange(): void {
        this.alertRuleChanged.emit();
    }
}
